import React from 'react';

const DesktopVersion = (props) => {
  const {
    fetchingClass,
    sharedRowClass,
    examNames,
    activeExamName,
    handleClick,
    descriptor = (_examName) => { return null; }
  } = props;
  const rowClassName = `${sharedRowClass} space-bottom d-none d-lg-flex${fetchingClass}`;

  return (
    <div className={rowClassName}>
      {examNames.map((examName, index) => {
        const active = activeExamName === examName ? ' active' : '';
        return (
          <div key={`select-exam-box-${index}`} className='col-md-2 col-sm-6'>
            <div
              className={`card select-box text-center small-text space-bottom-small pointer${active}`}
            >
              <div
                className='push-small'
                onClick={() => handleClick(index)}
                children={examName}
              />

              {descriptor(examName)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const MobileVersion = (props) => {
  const {
    fetchingClass,
    sharedRowClass,
    examNames,
    activeExamName,
    handleSelect
  } = props;

  const rowClassName = `${sharedRowClass} d-lg-none${fetchingClass}`;
  const selectClassName = 'custom-select medium-text space-top-small space-bottom-small';
  const selectedIndex = examNames.findIndex((name) => name === activeExamName);

  return (
    <div className={rowClassName}>
      <select className={selectClassName} defaultValue={selectedIndex} onChange={handleSelect}>
        {examNames.map((examName, index) => {
          return (
            <option
              key={`custom-exam-select-option-${index}`}
              className='custom-select-option'
              value={index}
              children={examName}
            />
          );
        })}
      </select>
    </div>
  );
};

class ExamFilterContainer extends React.PureComponent {
  handleSelect = (e) => {
    const { handleClick } = this.props;
    const selectedIndex = e.target.options[e.target.selectedIndex].value;
    handleClick(selectedIndex);
  }

  render() {
    const { fetching, handleClick } = this.props;
    const fetchingClass = fetching ? ' disabled-element' : '';
    const sharedRowClass = 'row align-items-center justify-content-center'
    const sharedProps = {
      fetchingClass,
      sharedRowClass,
      ...this.props
    };

    return (
      <React.Fragment>
        <DesktopVersion {...sharedProps} handleClick={handleClick} />
        <MobileVersion {...sharedProps} handleSelect={this.handleSelect} />
      </React.Fragment>
    );
  }
}

export default ExamFilterContainer;
